<a
  ftrButton
  [color]="color"
  [displayType]="displayType"
  [size]="size"
  [fullWidth]="fullWidth"
  [direction]="direction"
  [disabled]="disabled"
  (click)="performAction()"
>
  <ng-content></ng-content>
</a>
